export var LableMap = {
  sumDate: "日期",
  districtCode: "商区码",
  discType: "商区类型",
  name: "账号",
  remark: "备注",
  newUIDCount: "注册数",
  newDirectUIDCount: "直推注册数",
  newFissionUIDCount: "分裂注册数",
  userFissionRatio: "用户分裂率",
  buyVIPCount: "VIP数",
  directBuyVIPCount: "直推VIP数",
  fissionBuyVIPCount: "分裂VIP数",
  buyVIPAmount: "VIP金额(元)",
  directBuyVIPAmount: "直推VIP金额(元)",
  fissionBuyVIPAmount: "分裂VIP金额(元)",
  buyVIPUIDCount: "VIP用户数",
  directBuyVIPUIDCount: "直推VIP用户数",
  fissionBuyVIPUIDCount: "分裂VIP用户数",
  buyVIDTaxAmount: "视频收益(元)",
  directBuyVIDTaxAmount: "直推视频收益(元)",
  fissionBuyVIDTaxAmount: "分裂视频收益(元)",
  consume: "消费(元)",
  directConsume: "直推消费(元)",
  fissionConsume: "分裂消费(元)",
  arpu: "ARPU",
  directARPU: "直推ARPU",
  fissionARPU: "分裂ARPU",
  newAndRechargeOrderCount: "新增充值单数",
  newAndRechargeOrderYuan: "新增充值金额(元)",
  rechargeCompleteOrderCount: "充值单数",
  directRechargePaidOrderCount: "直推充值单数",
  fissionRechargePaidOrderCount: "分裂充值单数",
  rechargeCompleteOrderAmount: "充值金额(元)",
  directRechargePaidAmount: "直推充值(元)",
  fissionRechargePaidAmount: "分裂充值(元)",
  withDrawOrderCount: "总提现单数",
  withDrawOrderAmount: "总提现(元)",
  withDrawCompleteOrderCount: "完成提现单数",
  withDrawCompleteOrderAmount: "完成提现(元)",
  withDrawPaidOrderCount: "出款单数",
  directWithDrawPaidOrderCount: "直推出款单数",
  fissionWithDrawPaidOrderCount: "分裂出款单数",
  withDrawPaidAmount: "出款金额(元)",
  directWithDrawPaidAmount: "直推出款(元)",
  fissionWithDrawPaidAmount: "分裂出款(元)",
  visitUIDCount: "日活跃",
  directVisitUIDCount: "直推日活跃",
  fissionVisitUIDCount: "分裂日活跃",
  nextDayRetainUIDRatio: "次日留存率",
  day3RetainUIDRatio: "3日留存率",
  day7RetainUIDRatio: "7日留存率",
  day15RetainUIDRatio: "15日留存率",
  day30RetainUIDRatio: "30日留存率",
  directNextDayRetainUIDRatio: "直推次日留存率",
  directDay3RetainUIDRatio: "直推3日留存率",
  directDay7RetainUIDRatio: "直推7日留存率",
  directDay15RetainUIDRatio: "直推15日留存率",
  directDay30RetainUIDRatio: "直推30日留存率",
  fissionNextDayRetainUIDRatio: "分裂次日留存率",
  fissionDay3RetainUIDRatio: "分裂3日留存率",
  fissionDay7RetainUIDRatio: "分裂7日留存率",
  fissionDay15RetainUIDRatio: "分裂15日留存率",
  fissionDay30RetainUIDRatio: "分裂30日留存率",
};
